import { Combobox } from "components/DesignSystem/Combobox/Combobox";
import { TextArea } from "components/DesignSystem/TextArea/TextArea";
import { TextInput } from "components/DesignSystem/TextInput/TextInput";
import { FileInput } from "components/FileInput/FileInput";
import { PERK_TYPE_OPTIONS, PerkType } from "constants/perksAdmin";
import { PerkTypeFields } from "./PerkTypeFields";

const IMAGE_ACCEPT = { "image/*": [] };

type PerkFormProps = {
  existingIconUrl?: string;
  perkType?: PerkType;
};

export const PerkForm = ({ existingIconUrl, perkType }: PerkFormProps) => {
  const selectedPerkType = PERK_TYPE_OPTIONS.find(
    (type) => type.value === perkType
  );

  return (
    <div className="t-flex t-flex-col t-gap-4 t-max-h-[65vh] t-overflow-y-auto t-pr-1">
      <TextInput name="name" label="Name" required />
      <TextInput name="heading" label="Heading" />
      <TextArea name="description" label="Description" required block />
      <TextInput name="offer_description" label="Offer Description" />
      <TextInput name="website" label="Website" />
      <TextInput name="contact_email" label="Contact Email" />
      <TextInput name="linkedin_url" label="LinkedIn URL" />
      <TextArea name="instructions" label="Instructions (Markdown)" block />
      <TextInput
        name="bg_color_hex"
        label="Background Color Hex (e.g. #F0F0F0)"
        type="color"
      />

      {existingIconUrl && (
        <a href={existingIconUrl} target="_blank" rel="noreferrer">
          <img
            src={existingIconUrl}
            alt="Current perk icon"
            className="t-h-10 t-w-10 t-rounded t-object-contain"
          />
        </a>
      )}
      <FileInput
        withForm
        name="icon"
        label="Icon"
        accept={IMAGE_ACCEPT}
        block
      />

      <Combobox
        withForm
        name="perk_type"
        label="Perk Type"
        required
        isClearable={false}
        options={PERK_TYPE_OPTIONS}
        defaultValue={selectedPerkType}
      />
      <PerkTypeFields />
    </div>
  );
};
